import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../api';

const EMOJIS = ['👍', '❤️', '🎉', '😂', '🤔'];

export default function Feed() {
  const [posts, setPosts] = useState([]);
  const [newPost, setNewPost] = useState('');
  const [comments, setComments] = useState({});
  const [showComments, setShowComments] = useState({});
  const [commentText, setCommentText] = useState({});

  const load = () => api('/hcm/posts').then(r => r.ok ? r.json() : []).then(setPosts).catch(() => {});
  useEffect(load, []);

  const handlePost = async (e) => {
    e.preventDefault(); if (!newPost.trim()) return;
    await api('/hcm/posts', {method: 'POST', body: JSON.stringify({content: newPost})});
    setNewPost(''); load();
  };

  const loadComments = async (postId) => {
    const r = await api(`/hcm/posts/${postId}/comments`);
    if (r.ok) { const data = await r.json(); setComments(prev => ({...prev, [postId]: data})); }
  };

  const toggleComments = (postId) => {
    const show = !showComments[postId];
    setShowComments(prev => ({...prev, [postId]: show}));
    if (show && !comments[postId]) loadComments(postId);
  };

  const handleComment = async (postId) => {
    const text = commentText[postId];
    if (!text?.trim()) return;
    await api(`/hcm/posts/${postId}/comments`, {method: 'POST', body: JSON.stringify({content: text})});
    setCommentText(prev => ({...prev, [postId]: ''}));
    loadComments(postId); load();
  };

  const react = async (postId, emoji) => {
    await api(`/hcm/posts/${postId}/react`, {method: 'POST', body: JSON.stringify({emoji})});
    load();
  };

  return (
    <Layout>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Feed</h2>
      <form onSubmit={handlePost} className="bg-white rounded-lg shadow p-4 mb-6">
        <textarea value={newPost} onChange={e => setNewPost(e.target.value)} rows={3} placeholder="Share something with your team..."
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none resize-none" />
        <div className="flex justify-end mt-2">
          <button type="submit" disabled={!newPost.trim()} className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 text-sm disabled:opacity-50">Post</button>
        </div>
      </form>

      <div className="space-y-4">
        {posts.map(post => (
          <div key={post.id} className="bg-white rounded-lg shadow p-5">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-9 h-9 bg-indigo-100 rounded-full flex items-center justify-center text-indigo-600 font-bold text-sm">{(post.authorName || '?')[0]}</div>
              <div>
                <p className="text-sm font-medium text-gray-900">{post.authorName || 'Unknown'}</p>
                <p className="text-xs text-gray-500">{post.createdAt ? new Date(post.createdAt).toLocaleString() : ''}</p>
              </div>
            </div>
            <p className="text-gray-800 whitespace-pre-wrap mb-3">{post.content}</p>
            <div className="flex items-center gap-2 mb-2">
              {EMOJIS.map(emoji => (
                <button key={emoji} onClick={() => react(post.id, emoji)}
                  className={`px-2 py-1 rounded-full text-sm border ${post.reactions?.[emoji] ? 'border-indigo-300 bg-indigo-50' : 'border-gray-200 hover:bg-gray-50'}`}>
                  {emoji} {post.reactions?.[emoji] || ''}
                </button>
              ))}
            </div>
            <button onClick={() => toggleComments(post.id)} className="text-sm text-gray-500 hover:text-indigo-600">
              {post.commentCount || 0} comment{post.commentCount !== 1 ? 's' : ''}
            </button>
            {showComments[post.id] && (
              <div className="mt-3 border-t pt-3 space-y-2">
                {(comments[post.id] || []).map(c => (
                  <div key={c.id} className="flex gap-2">
                    <div className="w-7 h-7 bg-gray-100 rounded-full flex items-center justify-center text-gray-500 font-bold text-xs flex-shrink-0">{(c.authorName || '?')[0]}</div>
                    <div className="bg-gray-50 rounded-lg px-3 py-2 flex-1">
                      <p className="text-xs font-medium text-gray-900">{c.authorName || 'Unknown'}</p>
                      <p className="text-sm text-gray-700">{c.content}</p>
                    </div>
                  </div>
                ))}
                <div className="flex gap-2">
                  <input value={commentText[post.id] || ''} onChange={e => setCommentText(prev => ({...prev, [post.id]: e.target.value}))}
                    onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); handleComment(post.id); }}}
                    placeholder="Write a comment..." className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-1 focus:ring-indigo-500 outline-none" />
                  <button onClick={() => handleComment(post.id)} className="text-sm text-indigo-600 hover:text-indigo-800 font-medium">Send</button>
                </div>
              </div>
            )}
          </div>
        ))}
        {posts.length === 0 && <div className="text-center py-12 bg-white rounded-lg shadow text-gray-500">No posts yet. Be the first to share!</div>}
      </div>
    </Layout>
  );
}
